// Lightweight click track (metronome) used by Session Hub / Live Mode
let ctx = null, timer = null, next = 0, beat = 0, bpmRef = 120, vol = 0.6, listeners = new Set();
export const click = {
  playing: false,
  start(bpm) {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    bpmRef = bpm; this.stop(true); this.playing = true; beat = 0; next = ctx.currentTime + 0.05;
    timer = setInterval(() => {
      while (next < ctx.currentTime + 0.1) {
        const o = ctx.createOscillator(), g = ctx.createGain();
        o.frequency.value = beat % 4 === 0 ? 1760 : 1100; o.type = "square";
        g.gain.setValueAtTime(vol * 0.3, next); g.gain.exponentialRampToValueAtTime(0.0001, next + 0.05);
        o.connect(g); g.connect(ctx.destination); o.start(next); o.stop(next + 0.06);
        const b = beat, t = next; setTimeout(() => listeners.forEach((l) => l(b % 4)), Math.max(0, (t - ctx.currentTime) * 1000));
        next += 60 / bpmRef; beat++;
      }
    }, 25);
    listeners.forEach((l) => l(-1));
  },
  setBpm(b) { bpmRef = b; },
  setVol(v) { vol = v; },
  stop(silent) { clearInterval(timer); this.playing = false; if (!silent) listeners.forEach((l) => l(-2)); },
  on(fn) { listeners.add(fn); return () => listeners.delete(fn); },
};
